export function trackEvent(eventName, params = {}) {
  if (!window.gtag) return;
  window.gtag('event', eventName, params);
}

export function toGaItem(product, quantity = 1) {
  return {
    item_id: String(product.id || product._id || product.slug || product.name),
    item_name: product.name,
    item_category: product.category || 'Coffee',
    item_brand: "Léger's Coffee",
    price: Number(product.price || 0),
    quantity,
  };
}